import React from "react";
import whatsappIcon from "./images/WhatsApp.png"; // Import PNG image
import "./css/whatsappButton.css"; // Import CSS file

const WhatsAppButton = () => {
  const phoneNumber = process.env.REACT_APP_WHATSAPP_PHONE; 

  return (
    <div className="whatsapp-button">
      <a href={`https://wa.me/${phoneNumber}`} target="_blank" rel="noopener noreferrer">
        <img src={whatsappIcon} alt="WhatsApp" className="whatsapp-icon" />
      </a>
    </div>
  );
};

export default WhatsAppButton;
